<template>
  <div class="col-12 col-lg-3 col-dir order-3 order-md-3">
    <div class="desempenho">
      <h2>Resultado</h2>
      <ul>
        <li><i class="fas fa-check-circle"></i><span>{{ desempenhoQuiz.questoes_acertadas }}</span> acertos</li>
        <li><i class="fas fa-exclamation-circle"></i><span>{{ desempenhoQuiz.questoes_incorretas }}</span> erros</li>
        <li><i class="far fa-circle"></i><span>{{ desempenhoQuiz.questoes_sem_resposta }}</span> não respondidas</li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Desempenho',
  props: {
    'desempenhoQuiz': Object
  }
}
</script>
